import app from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";

//Modular way
import * as FS from "firebase/firestore";

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
class Firebase {
  auth: app.auth.Auth;
  db: app.database.Database;
  fs: app.firestore.Firestore;
  storage: app.storage.Storage;
  modularFs: FS.Firestore;
  firebaseApp: app.app.App;
  firestoreId: string | undefined;

  constructor() {
    this.firebaseApp = app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.database();
    this.fs = app.firestore();
    // Force long-polling for the compat Firestore client so it works
    // through corporate / hospital proxies and AV that break WebChannel.
    // experimentalAutoDetectLongPolling defaults to true in recent SDKs, so
    // we must explicitly disable it to avoid the "cannot be used together"
    // validation error. Must be called before any read/write on this.fs.
    this.fs.settings({
      experimentalForceLongPolling: true,
      experimentalAutoDetectLongPolling: false,
      merge: true,
    });
    this.storage = app.storage();
    this.firestoreId = process.env.REACT_APP_FIRESTORE_ID;
    this.modularFs = FS.initializeFirestore(
      this.firebaseApp,
      {
        experimentalForceLongPolling: true,
        experimentalAutoDetectLongPolling: false,
      },
      this.firestoreId
    );
  }

  database = () => this.db;

  currentUser = () => this.auth.currentUser;

  signInWithEmailAndPassword = (email: string, password: string) =>
    this.auth.signInWithEmailAndPassword(email, password);

  signOut = () => this.auth.signOut();

  modularFirestore = () => this.modularFs;
  modularFirestoreBatch = () => FS.writeBatch(this.modularFs);
}

const firebase = new Firebase();
export default firebase;

export { FS };
